export const TERMSCONDITIONS_CMS_DATA = 'TERMSCONDITIONS_CMS_DATA';
export const SHOW_LOADER = 'SHOW_LOADER';
